import React from 'react';
import Flexbox from 'flexbox-react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { inject, observer } from 'mobx-react';
import {
  Alert,
  Button,
  Classes,
  Intent,
  Switch,
  HTMLSelect,
  Tooltip,
  Icon,
} from '@blueprintjs/core';
import UserAvatar from '../shared/UserAvatar';

@inject('AccountUsersStore', 'ToastStore')
@observer
export default class AccountUsersRow extends React.Component {
  static jobProfilesCache = null;
  static jobProfilesPromise = null;
  constructor(props) {
    super(props);

    this.state = {
      isMakingOwner: false,
      isRemovingOwner: false,
      isRemovingUser: false,
      jobProfileId:
        props.user.job_profile?.id ||
        props.user.job_profile_id ||
        props.user.jobProfileId ||
        '',
    };
  }

  componentDidMount() {
    this.fetchJobProfiles();
  }

  componentDidUpdate(prevProps) {
    const prevProfiles = prevProps.AccountUsersStore.jobProfiles;
    const currentProfiles = this.props.AccountUsersStore.jobProfiles;

    if (prevProfiles.length > 0 && currentProfiles.length === 0) {
      this.setState({ jobProfileId: '' });
    }

    if (prevProps.user?.id !== this.props.user?.id) {
      this.setState({
        jobProfileId:
          this.props.user.job_profile?.id ||
          this.props.user.job_profile_id ||
          '',
      });
    }
  }

  toggleMakingOwner() {
    this.setState({
      isMakingOwner: !this.state.isMakingOwner,
    });
  }

  toggleRemovingOwner() {
    this.setState({
      isRemovingOwner: !this.state.isRemovingOwner,
    });
  }

  toggleRemovingUser() {
    this.setState({
      isRemovingUser: !this.state.isRemovingUser,
    });
  }

  handleSendInvitation() {
    const email = this.props.user.email;
    this.props.AccountUsersStore.updateNewInvitation(
      this.props.user.email,
      'email'
    );
    this.props.AccountUsersStore.createInvitation().then(response => {
      this.props.ToastStore.showToast(
        I18n.t('js.invitation_has_been_sent', {
          email: email,
        }),
        'success'
      );
    });
  }

  handleMakeOwner(user) {
    const newObj = {
      account_owner: true,
    };
    this.props.AccountUsersStore.changeUser(
      this.props.user.id,
      newObj
    )
      .then(() => {
        this.props.user.isAccountOwner = true;
        this.toggleMakingOwner();
        this.props.ToastStore.showToast(
          I18n.t('js.user_has_been_made_owner', {
            name: user.fullName,
          }),
          'success'
        );
      })
      .catch(() => {
        this.toggleMakingOwner();
      });
  }

  handleRemoveOwner(user) {
    const newObj = {
      account_owner: false,
    };
    this.props.AccountUsersStore.changeUser(
      this.props.user.id,
      newObj
    )
      .then(() => {
        this.props.user.isAccountOwner = false;
        this.toggleRemovingOwner();
        this.props.ToastStore.showToast(
          I18n.t('js.user_has_been_removed_owner', {
            name: user.fullName,
          }),
          'success'
        );
      })
      .catch(() => {
        this.toggleRemovingOwner();
      });
  }

  handleRemoveUser() {
    this.props.AccountUsersStore.deleteUser(this.props.user.id)
      .then(() => {
        this.toggleRemovingUser();
        this.props.ToastStore.showToast(
          I18n.t('js.user_has_been_removed'),
          'success'
        );
      })
      .catch(() => {
        this.toggleRemovingUser();
      });
  }

  renderMakeOwner() {
    return (
      <Alert
        portalContainer={document.body}
        isOpen={this.state.isMakingOwner}
        cancelButtonText={I18n.t('js.cancel')}
        onCancel={() => this.toggleMakingOwner()}
        confirmButtonText={I18n.t('js.make_user_owner')}
        onConfirm={() => this.handleMakeOwner(this.props.user)}
        intent={Intent.SUCCESS}
      >
        <h4 className={Classes.HEADING}>
          {I18n.t('js.are_you_sure')}
        </h4>
        {I18n.t(
          'js.are_you_sure_you_wish_to_make_this_user_an_account_owner',
          { name: this.props.user.fullName }
        )}
      </Alert>
    );
  }

  renderRemoveOwner() {
    return (
      <Alert
        portalContainer={document.body}
        isOpen={this.state.isRemovingOwner}
        cancelButtonText={I18n.t('js.cancel')}
        onCancel={() => this.toggleRemovingOwner()}
        confirmButtonText={I18n.t('js.remove_account_ownership')}
        onConfirm={() => this.handleRemoveOwner(this.props.user)}
        intent={Intent.DANGER}
      >
        <h4 className={Classes.HEADING}>
          {I18n.t('js.are_you_sure')}
        </h4>
        {I18n.t(
          'js.are_you_sure_you_wish_to_remove_this_account_owner',
          { name: this.props.user.fullName }
        )}
      </Alert>
    );
  }

  renderRemoveUser() {
    return (
      <Alert
        portalContainer={document.body}
        isOpen={this.state.isRemovingUser}
        cancelButtonText={I18n.t('js.cancel')}
        onCancel={() => this.toggleRemovingUser()}
        confirmButtonText={I18n.t('js.remove_user')}
        onConfirm={() => this.handleRemoveUser(this.props.user)}
        intent={Intent.DANGER}
      >
        <h4 className={Classes.HEADING}>
          {I18n.t('js.are_you_sure')}
        </h4>
        {I18n.t('js.are_you_sure_you_wish_to_remove_this_user', {
          name: this.props.user.fullName,
        })}
      </Alert>
    );
  }

  handleJobProfileChange = e => {
    const jobProfileId = e.target.value;

    this.setState({ jobProfileId });

    this.props.AccountUsersStore
      .changeUser(this.props.user.id, {
        job_profile_id: jobProfileId || null,
      })
      .catch(() => {
        this.setState({
          jobProfileId: this.props.user.job_profile?.id || '',
          jobProfileId:
            this.props.user.job_profile?.id ||
            this.props.user.job_profile_id ||
            '',
        });
      });
  };

  fetchJobProfiles = () => {
    if (AccountUsersRow.jobProfilesCache) {
      this.setState({ jobProfiles: AccountUsersRow.jobProfilesCache });
      return;
    }

    if (AccountUsersRow.jobProfilesPromise) {
      AccountUsersRow.jobProfilesPromise.then(data => {
        this.setState({ jobProfiles: data });
      });
      return;
    }

    const baseUrl = Cookies.get('apiEnv');
    if (!baseUrl) return;

    this.setState({ isJobProfilesLoading: true });

    AccountUsersRow.jobProfilesPromise = axios
      .get(`${baseUrl}/job_profiles`)
      .then(response => {
        const data = Array.isArray(response.data) ? response.data : [];
        AccountUsersRow.jobProfilesCache = data;

        this.setState(prev => ({
          jobProfiles: data,
          jobProfileId: prev.jobProfileId || this.props.user.job_profile?.id || '',
        }));

        return data;
      })
      .catch(error => {
        const message =
          error?.response?.data?.error?.join?.(', ') ||
          error?.response?.data?.error ||
          'Unable to load job profiles';

        this.props.ToastStore?.showToast?.(message, 'danger');
        throw error;
      })
      .finally(() => {
        this.setState({ isJobProfilesLoading: false });
      });
  };

  render() {
    const { jobProfileId } = this.state;
    const { AccountUsersStore } = this.props;

    const jobProfiles = AccountUsersStore?.jobProfiles || [];
    const isJobProfilesLoading = AccountUsersStore?.isJobProfilesLoading;

    return (
      <tr>
        <td>
          <UserAvatar
            user={this.props.user}
            avatarSize={20}
            path={`/users/${this.props.user.humanFriendlyId}`}
          />
        </td>

        <td>
          <Flexbox alignItems="center">
            <div
              style={
                !jobProfileId
                  ? {
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #D9822B",
                    borderRadius: "6px",
                    width: "100%",
                    boxSizing: "border-box",
                  }
                  : { width: "100%" }
              }
            >
              <HTMLSelect
                fill
                minimal
                value={jobProfileId}
                disabled={isJobProfilesLoading}
                onChange={this.handleJobProfileChange}
                options={[
                  { label: "Select job profile", value: "" },
                  ...jobProfiles.map(jp => ({
                    label: jp.name,
                    value: String(jp.id),
                  })),
                ]}
              />
            </div>

            {!jobProfileId && (
              <Tooltip content="Action needed">
                <Icon
                  icon="warning-sign"
                  intent={Intent.DANGER}
                  style={{ marginLeft: 8, cursor: "pointer" }}
                />
              </Tooltip>
            )}
          </Flexbox>
        </td>

        <td>{this.props.user.lastSignInAtToDate}</td>
        <td>
          <Flexbox
            flexGrow={1}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <Switch
              checked={this.props.user.isAccountOwner}
              className="bp3-control-no-margin"
              onChange={
                this.props.user.isAccountOwner
                  ? this.toggleRemovingOwner.bind(this)
                  : this.toggleMakingOwner.bind(this)
              }
            />
          </Flexbox>
        </td>
        <td>
          <Button
            className="bp3-small"
            text={I18n.t('js.remove_user')}
            onClick={() => this.toggleRemovingUser()}
          />
          <Button
            className="bp3-small push-5-l"
            text={I18n.t('js.send_invitation')}
            disabled={this.props.user.lastSignInAt.length > 0}
            onClick={() => this.handleSendInvitation()}
          />
        </td>
        {this.renderMakeOwner()}
        {this.renderRemoveOwner()}
        {this.renderRemoveUser()}
      </tr>
    );
  }
}

